import { type WorkflowData, type WorkflowListInput, type WorkflowListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse, type WithEnabled } from '../hooks'
import { workflowListKey } from './keys'
import { useWorkflowCache } from './cache'

export type UseWorkflowsProps = WithEnabled & WorkflowListInput

export function useWorkflows({ enabled, ...input }: UseWorkflowsProps = {}): GetHookResponse<WorkflowData[]> {
  const { setItem } = useWorkflowCache()
  return useTantalimQuery<WorkflowListInput, WorkflowListSuccess, WorkflowData[]>({
    url: '/workflow/list',
    queryKey: workflowListKey(input),
    input,
    convertResponse: (responseData) => {
      responseData.workflows.sort((a, b) => a.name.localeCompare(b.name))
      responseData.workflows.forEach((w) => setItem(w))
      return responseData.workflows
    },
    options: {
      enabled,
    },
  })
}
